import { render, staticRenderFns } from "./SettingsDetailsContainer.vue?vue&type=template&id=80c59914&scoped=true"
import script from "./SettingsDetailsContainer.vue?vue&type=script&lang=js"
export * from "./SettingsDetailsContainer.vue?vue&type=script&lang=js"
import style0 from "./SettingsDetailsContainer.vue?vue&type=style&index=0&id=80c59914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c59914",
  null
  
)

export default component.exports